import React from 'react';

const HowItWorks: React.FC = () => {
  const sectionStyle: React.CSSProperties = {
    padding: '10rem 0',
  };

  const headerStyle: React.CSSProperties = {
    marginBottom: '6rem',
    maxWidth: '800px',
  };

  const stepGridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '2rem',
    marginBottom: '6rem',
  };

  const stepCardStyle: React.CSSProperties = {
    padding: '2.5rem 2rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  };

  const insightExampleStyle: React.CSSProperties = {
    padding: '2.5rem',
    borderLeft: '4px solid var(--status-danger)',
  };

  return (
    <section style={sectionStyle} id="how-it-works">
      <div className="container">
        <div style={headerStyle}>
          <span className="mono-label">How It Works</span>
          <h2>From upload to answers.</h2>
        </div>

        <div style={stepGridStyle}>
          <div className="matte-surface" style={stepCardStyle}>
            <span style={{ color: 'var(--gabmic-orange)', fontSize: '2rem', fontWeight: 800 }}>1.</span>
            <h3 style={{ fontSize: '1.25rem', marginBottom: '0' }}>Upload</h3>
            <p style={{ fontSize: '1rem', marginBottom: '0' }}>Add a CSV or Excel file from sales, finance, marketing, or other business operations.</p>
          </div>
          <div className="matte-surface" style={stepCardStyle}>
            <span style={{ color: 'var(--gabmic-orange)', fontSize: '2rem', fontWeight: 800 }}>2.</span>
            <h3 style={{ fontSize: '1.25rem', marginBottom: '0' }}>Analyze</h3>
            <p style={{ fontSize: '1rem', marginBottom: '0' }}>Review detected dates, metrics, categories, and text fields before analysis begins.</p>
          </div>
          <div className="matte-surface" style={stepCardStyle}>
            <span style={{ color: 'var(--gabmic-orange)', fontSize: '2rem', fontWeight: 800 }}>3.</span>
            <h3 style={{ fontSize: '1.25rem', marginBottom: '0' }}>Review</h3>
            <p style={{ fontSize: '1rem', marginBottom: '0' }}>View charts, tables, comparisons, summaries, and ask GabMic questions about the real data.</p>
          </div>
        </div>

        <div className="matte-surface" style={insightExampleStyle}>
          <span className="mono-label">Example Question</span>
          <h3 style={{ marginBottom: '0.5rem' }}>“What changed compared with last month?”</h3>
          <p style={{ color: 'var(--text-main)', fontWeight: 600, margin: 0 }}>
            GabMic answers from the uploaded rows instead of inventing results.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
